import * as React from 'react';
import { observer } from 'mobx-react';
import { TrackersStatusWidgets } from 'components/mywellness/TrackersStatusWidgets';
import { UIState, WellnessTabs } from 'data/UIState';
import { computed } from 'mobx';


import './TrackersBar.pcss';
import { IconButton } from 'components/widgets/IconButton';
import {PageEnums} from "components/nav/PageEnums";

interface TrackersBar_P {
	contentScrollY:number;
}

@observer
export class TrackersBar extends React.Component<TrackersBar_P> {

	@computed
	get collapsed() {
	return UIState.fullsizedHeader-this.props.contentScrollY<=64;
	}

	@computed 
	get widgetsStyle() {
		let widgetsStyle:any = {};
		if(this.collapsed) {
			widgetsStyle.bottom = '0px';
		} else {
			widgetsStyle.top = (-this.props.contentScrollY)+'px';
		}
		return widgetsStyle;
	}

	@computed
	get trackersBarStyle() {
		return {
			height: (this.collapsed?64:UIState.fullsizedHeader-this.props.contentScrollY)+'px'
		}
	}

	@computed 
	get barHeight(){
		return (this.collapsed?64:UIState.fullsizedHeader-this.props.contentScrollY)+'px';
	}

	render(){
		return (
			<div className="trackers-bar" style={{height:this.barHeight}}>
				<div className={`bar-container${this.collapsed?' mini':''}`}>
					<TrackersStatusWidgets mini={this.collapsed} />
				</div>
				<div className="my-wellness-button" style={{lineHeight:this.barHeight}}>
					<IconButton big onClick={()=>{
						UIState.wellnessTab=WellnessTabs.TRACKERS;
						UIState.currentPage = PageEnums.myWellness; }}>arrow_forward</IconButton>
				</div>
			</div>
		);		
	}
}



